export default __webpack_public_path__ + "static/media/solution_success_spy_icon.742085dc.svg";